import React, { useRef, useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';
import SEO from '../../components/SEO';

const SentinelPage = ({ setRefs }) => {
  const sentinelRef = useRef(null);
  const featuresRef = useRef(null);
  const pricingRef = useRef(null);
  const howToRef = useRef(null);

  useEffect(() => {
    setRefs({ 
      sentinel: sentinelRef,
      features: featuresRef,
      pricing: pricingRef,
      'how-to': howToRef
    });
  }, [setRefs]);

  return (
    <>
      <SEO
        title="Sentinel"
        description="Sentinel - Advanced monitoring and security solutions."
        keywords="sentinel, monitoring, security, surveillance"
      />
      
      <Box ref={sentinelRef} id="sentinel" sx={{ minHeight: '100vh', pt: 8 }}>
        <Container maxWidth="lg">
          <Typography variant="h1" sx={{ mb: 4 }}>
            Sentinel
          </Typography>
          
          {/* Features Section */}
          <Box ref={featuresRef} id="features" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              Features
            </Typography>
            <Typography variant="body1">
              Sentinel features content will go here...
            </Typography>
          </Box>
          
          {/* Pricing Section */}
          <Box ref={pricingRef} id="pricing" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              Pricing
            </Typography>
            <Typography variant="body1">
              Sentinel pricing content will go here...
            </Typography>
          </Box>
          
          {/* How To Section */}
          <Box ref={howToRef} id="how-to" sx={{ minHeight: '80vh', py: 8 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              How To
            </Typography>
            <Typography variant="body1">
              Sentinel how to content will go here...
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default SentinelPage;
